module.exports = __webpack_public_path__ + "static/media/retweet-alt.4a609bb7.svg";